import { useState } from 'react';

import Button from '@r1-frontend/ui-react/components/buttons/button';
import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import SlideCarousel from '@r1-frontend/ui-react/components/SlideCarousel';
import { H2 } from '@r1-frontend/ui-react/components/typography/heading';
import { Paragraph3 } from '@r1-frontend/ui-react/components/typography/paragraph';
import WebpImage from '@r1-frontend/ui-react/components/WebpImage';
import { IndentContainer } from '@r1-frontend/ui-react/experimental/containers';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { useMatchMedia, useMatchMediaByWidth } from '@r1-frontend/shared/hooks/useMatchMedia';

import { TPreparedContentBlocks } from '~/src/features/aboutV2/helpers';

import * as ST from './styled';

interface IProps {
    history: TPreparedContentBlocks[],
}

const History = ({ history }: IProps) => {
    const isLaptop = useMatchMedia(`(max-width: ${wideBreakpoints.laptop}) and (min-width: ${wideBreakpoints.mobile})`);
    const isMobile = useMatchMediaByWidth(wideBreakpoints.mobile);

    const [activeCard, setActiveCard] = useState(history[0]);

    const handleSlideClick = (id: number) => () => {
        const selectedHistory = history.find(el => el.id === id);
        if (selectedHistory) {
            setActiveCard(selectedHistory);
        }
    };

    return (
        <ST.History>
            <H2 $smaller={isLaptop}>История Дом.ру</H2>
            <IndentContainer $united={[0, 0, 32]}>
                <SlideCarousel data-test='carousel' cellSpacing={0} slideWidth={isMobile ? 100 : 110} withoutArrows withoutDots>
                    {history.map(({ alias, id }) => (
                        activeCard.id === id
                            ? (
                                <Button data-test='btn-primary' size='small' bType='primary' onClick={handleSlideClick(id)} key={id}>
                                    <ST.ButtonText as='span' $withIndent={false} customColor={COLORS.TextWhite}>{alias}</ST.ButtonText>
                                </Button>
                            )
                            : (
                                <Button data-test='btn-secondary' size='small' bType='secondary' onClick={handleSlideClick(id)} key={id}>
                                    <ST.ButtonText as='span' $withIndent={false} customColor={COLORS.Link}>{alias}</ST.ButtonText>
                                </Button>
                            )
                    ))}
                </SlideCarousel>
            </IndentContainer>
            <ST.SBlockContainer indent={{ $mobile: [16], $desktop: [32] }} rounder={{ $mobile: 24, $desktop: 32 }}>
                <ST.ImageWrapper $radius={24}>
                    <WebpImage urlWebp={activeCard.imgWebp}>
                        <img data-test='card-image' src={activeCard.img} alt={'Изображение, показывающее год в истории компании'} />
                    </WebpImage>
                </ST.ImageWrapper>
                <ST.SH2 $smaller $withIndent={false} dangerouslySetInnerHTML={{ __html: activeCard.title }} />
                <ST.SPre $whiteSpace='pre-wrap' $withIndent={false}>
                    <Paragraph3 as='div' dangerouslySetInnerHTML={{ __html: activeCard.desc }} />
                </ST.SPre>
            </ST.SBlockContainer>
        </ST.History>
    );
};

export default History;
